// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var Curry = require("rescript/lib/js/curry.js");
var React = require("react");
var Common = require("../utils/Common.bs.js");
var Caml_array = require("rescript/lib/js/caml_array.js");
var MM_context = require("../mm-utils/MM_context.bs.js");
var MM_provers = require("../mm-utils/MM_provers.bs.js");
var Belt_Option = require("rescript/lib/js/belt_Option.js");
var Belt_Result = require("rescript/lib/js/belt_Result.js");
var Caml_option = require("rescript/lib/js/caml_option.js");
var MM_wrk_unify = require("../worker/MM_wrk_unify.bs.js");
var MM_wrk_client = require("../worker/MM_wrk_client.bs.js");
var MM_wrk_editor = require("../worker/MM_wrk_editor.bs.js");
var Belt_MapString = require("rescript/lib/js/belt_MapString.js");
var Expln_React_Row = require("../../rescript-utils/main/react-mui-components/Expln_React_Row.bs.js");
var MM_react_common = require("../ui-utils/MM_react_common.bs.js");
var Expln_React_Menu = require("../../rescript-utils/main/react-mui-components/Expln_React_Menu.bs.js");
var MM_cmp_user_stmt = require("./MM_cmp_user_stmt.bs.js");
var Expln_React_Modal = require("../../rescript-utils/main/react-components/Expln_React_Modal.bs.js");
var MM_editor_history = require("../worker/MM_editor_history.bs.js");
var Expln_React_Column = require("../../rescript-utils/main/react-mui-components/Expln_React_Column.bs.js");
var Expln_utils_common = require("../../rescript-utils/main/Expln_utils_common.bs.js");
var JsxPPXReactSupport = require("rescript/lib/js/jsxPPXReactSupport.js");
var MM_cmp_editor_hist = require("./MM_cmp_editor_hist.bs.js");
var MM_cmp_search_asrt = require("./MM_cmp_search_asrt.bs.js");
var MM_wrk_editor_json = require("../test/MM_wrk_editor_json.bs.js");
var Static_XML_to_HTML = require("../utils/Static_XML_to_HTML.bs.js");
var Paper = require("@mui/material/Paper").default;
var Expln_utils_promise = require("../../rescript-utils/main/Expln_utils_promise.bs.js");
var Local_storage_utils = require("../ui-utils/Local_storage_utils.bs.js");
var MM_cmp_export_proof = require("./MM_cmp_export_proof.bs.js");
var MM_cmp_substitution = require("./MM_cmp_substitution.bs.js");
var XML_formatting_help = require("../utils/XML_formatting_help.bs.js");
var Button = require("@mui/material/Button").default;
var MM_cmp_multiline_text = require("./MM_cmp_multiline_text.bs.js");
var Checkbox = require("@mui/material/Checkbox").default;
var MenuItem = require("@mui/material/MenuItem").default;
var MM_cmp_merge_two_stmts = require("./MM_cmp_merge_two_stmts.bs.js");
var MM_cmp_save_or_discard = require("./MM_cmp_save_or_discard.bs.js");
var MM_cmp_unify_bottom_up = require("./MM_cmp_unify_bottom_up.bs.js");
var Add = require("@mui/icons-material/Add").default;
var Hub = require("@mui/icons-material/Hub").default;
var MM_cmp_import_from_json = require("./MM_cmp_import_from_json.bs.js");
var Menu = require("@mui/icons-material/Menu").default;
var IconButton = require("@mui/material/IconButton").default;
var Search = require("@mui/icons-material/Search").default;
var MM_cmp_editor_view_options = require("./MM_cmp_editor_view_options.bs.js");
var MM_cmp_export_state_to_url = require("./MM_cmp_export_state_to_url.bs.js");
var Restore = require("@mui/icons-material/Restore").default;
var MM_cmp_export_state_to_json = require("./MM_cmp_export_state_to_json.bs.js");
var MergeType = require("@mui/icons-material/MergeType").default;
var ArrowUpward = require("@mui/icons-material/ArrowUpward").default;
var ArrowDownward = require("@mui/icons-material/ArrowDownward").default;
var DeleteForever = require("@mui/icons-material/DeleteForever").default;
var Expln_React_ContentWithStickyHeader = require("../../rescript-utils/main/react-components/Expln_React_ContentWithStickyHeader.bs.js");
var TextRotationNone = require("@mui/icons-material/TextRotationNone").default;
var ControlPointDuplicate = require("@mui/icons-material/ControlPointDuplicate").default;

var unifyAllIsRequiredCnt = {
  contents: 0
};

function editorSaveStateToLocStor(state, key, tempMode) {
  if (!tempMode) {
    return Local_storage_utils.locStorWriteString(key, Expln_utils_common.stringify(MM_wrk_editor_json.editorStateToEditorStateLocStor(state)));
  }
  
}

var editorHistRegLocStorKey = "hist-reg";

var editorHistTmpLocStorKey = "hist-tmp";

function getHistLockStorKey(tempMode) {
  if (tempMode) {
    return editorHistTmpLocStorKey;
  } else {
    return editorHistRegLocStorKey;
  }
}

function histSaveToLocStor(hist, tempMode) {
  var histStr = MM_editor_history.editorHistToString(hist);
  Local_storage_utils.locStorWriteString(tempMode ? editorHistTmpLocStorKey : editorHistRegLocStorKey, histStr);
}

function histReadFromLocStor(editorState, tempMode, maxLength) {
  var histStr = Local_storage_utils.locStorReadString(tempMode ? editorHistTmpLocStorKey : editorHistRegLocStorKey);
  if (histStr === undefined) {
    return MM_editor_history.editorHistMake(editorState, maxLength);
  }
  var hist = MM_editor_history.editorHistFromString(histStr);
  if (hist.TAG === /* Ok */0) {
    return MM_editor_history.editorHistAddSnapshot(hist._0, editorState);
  } else {
    return MM_editor_history.editorHistMake(editorState, maxLength);
  }
}

function rndIconButton(icon, onClick, active, notifyEditInTempMode, ref, title, smallBtnsOpt, param) {
  var smallBtns = smallBtnsOpt !== undefined ? smallBtnsOpt : false;
  return React.createElement("span", {
              ref: ref,
              title: title
            }, React.createElement(IconButton, {
                  onClick: (function (param) {
                      if (notifyEditInTempMode !== undefined) {
                        return Curry._1(notifyEditInTempMode, (function (param) {
                                      Curry._1(onClick, undefined);
                                    }));
                      } else {
                        return Curry._1(onClick, undefined);
                      }
                    }),
                  color: "primary",
                  style: smallBtns ? ({
                        padding: "2px"
                      }) : undefined,
                  disabled: !active,
                  children: Caml_option.some(icon)
                }));
}

var editorStateLocStorKey = "editor-state";

var lastUsedAsrtSearchTypLocStorKey = "search-asrt-typ";

function saveLastUsedTyp(ctx, typInt, tempMode) {
  if (tempMode) {
    return ;
  }
  var typStr = MM_context.ctxIntToSym(ctx, typInt);
  if (typStr !== undefined) {
    localStorage.setItem(lastUsedAsrtSearchTypLocStorKey, typStr);
    return ;
  }
  
}

function getLastUsedTyp(ctx) {
  var typStr = localStorage.getItem(lastUsedAsrtSearchTypLocStorKey);
  if (typStr !== null) {
    return MM_context.ctxSymToInt(ctx, typStr);
  }
  
}

function jsonStrOptToEditorStateLocStor(jsonStrOpt) {
  return Belt_Option.flatMap(jsonStrOpt, (function (jsonStr) {
                return Belt_Result.mapWithDefault(MM_wrk_editor_json.readEditorStateFromJsonStr(jsonStr), undefined, (function (state) {
                              return state;
                            }));
              }));
}

var previousEditingIsNotCompletedTitle = "Previous editing is not completed";

var previousEditingIsNotCompletedText = "You've attempted to edit something in the editor while the previous edit is not complete. Please complete the previous edit before starting a new one.";

var editingInTempModeTitle = "Editing in TEMP mode";

var editingInTempModeText = "You are about to edit in TEMP mode. All changes you do in TEMP mode will be erased upon closing current browser tab. If you want to continue editing in regular mode, please do the following actions: 1) use \"Export to JSON\" to copy current editor state to the clipboard; 2) open a new tab (or switch to an already opened tab) with metamath-lamp in regular mode; 3) use \"Import from JSON\" to load the copied editor state from the clipboard.";

function MM_cmp_editor(props) {
  var setShowTabs = props.setShowTabs;
  var showTabs = props.showTabs;
  var openCtxSelector = props.openCtxSelector;
  var tempMode = props.tempMode;
  var initialStateJsonStr = props.initialStateJsonStr;
  var reloadCtx = props.reloadCtx;
  var preCtxData = props.preCtxData;
  var modalRef = props.modalRef;
  var match = React.useState(function () {
        return false;
      });
  var setMainMenuIsOpened = match[1];
  var mainMenuIsOpened = match[0];
  var mainMenuButtonRef = React.useRef(null);
  var match$1 = React.useState(function () {
        return false;
      });
  var setWarnedAboutTempMode = match$1[1];
  var warnedAboutTempMode = match$1[0];
  var match$2 = Local_storage_utils.useStateFromLocalStorageBool("editor-showCheckbox", true, tempMode);
  var setShowCheckbox = match$2[1];
  var showCheckbox = match$2[0];
  var match$3 = Local_storage_utils.useStateFromLocalStorageBool("editor-showLabel", true, tempMode);
  var setShowLabel = match$3[1];
  var showLabel = match$3[0];
  var match$4 = Local_storage_utils.useStateFromLocalStorageBool("editor-showType", true, tempMode);
  var setShowType = match$4[1];
  var showType = match$4[0];
  var match$5 = Local_storage_utils.useStateFromLocalStorageBool("editor-showJstf", true, tempMode);
  var setShowJstf = match$5[1];
  var showJstf = match$5[0];
  var match$6 = Local_storage_utils.useStateFromLocalStorageBool("editor-inlineMode", false, tempMode);
  var setInlineMode = match$6[1];
  var inlineMode = match$6[0];
  var match$7 = Local_storage_utils.useStateFromLocalStorageBool("editor-smallBtns", false, tempMode);
  var setSmallBtns = match$7[1];
  var smallBtns = match$7[0];
  var match$8 = React.useState(function () {
        return MM_wrk_editor_json.createInitialEditorState(preCtxData.settingsV.ver, preCtxData.settingsV.val, preCtxData.srcs, preCtxData.ctxV.ver, preCtxData.ctxV.val, jsonStrOptToEditorStateLocStor(initialStateJsonStr));
      });
  var setStatePriv = match$8[1];
  var state = match$8[0];
  var match$9 = React.useState(function () {
        return histReadFromLocStor(state, tempMode, preCtxData.settingsV.val.editorHistMaxLength);
      });
  var setHistPriv = match$9[1];
  var hist = match$9[0];
  var setHist = function (update) {
    Curry._1(setHistPriv, (function (ht) {
            var ht$1 = Curry._1(update, ht);
            histSaveToLocStor(ht$1, tempMode);
            return ht$1;
          }));
  };
  var setState = function (update) {
    Curry._1(setStatePriv, (function (st) {
            var st$1 = MM_wrk_editor.updateEditorStateWithPostupdateActions(st, update);
            editorSaveStateToLocStor(st$1, editorStateLocStorKey, tempMode);
            setHist(function (ht) {
                  return MM_editor_history.editorHistAddSnapshot(ht, st$1);
                });
            return st$1;
          }));
  };
  var notifyEditInTempMode = function ($$continue) {
    if (tempMode && !warnedAboutTempMode) {
      return MM_react_common.openInfoDialog(modalRef, editingInTempModeText, (function (param) {
                    Curry._1(setWarnedAboutTempMode, (function (param) {
                            return true;
                          }));
                    Curry._1($$continue, undefined);
                  }), editingInTempModeTitle, undefined);
    } else {
      return Curry._1($$continue, undefined);
    }
  };
  var editIsActive = MM_wrk_editor.isEditMode(state);
  var thereAreSyntaxErrors = MM_wrk_editor.editorStateHasErrors(state);
  var atLeastOneStmtIsChecked = state.checkedStmtIds.length !== 0;
  var atLeastOneStmtHasSelectedText = Belt_Option.isSome(Caml_option.undefined_to_opt(state.stmts.find(function (stmt) {
                return MM_wrk_editor.hasSelectedText(stmt.cont);
              })));
  var atLeastOneStmtIsNotChecked = state.stmts.length !== state.checkedStmtIds.length;
  var mainCheckboxState = (atLeastOneStmtIsChecked || atLeastOneStmtHasSelectedText) && atLeastOneStmtIsNotChecked ? undefined : (
      atLeastOneStmtIsChecked && !atLeastOneStmtIsNotChecked ? true : false
    );
  var generalModificationActionIsEnabled = !editIsActive && !thereAreSyntaxErrors;
  var stmt = MM_wrk_editor.getTheOnlyCheckedStmt(state);
  var singleProvableChecked = stmt !== undefined && stmt.typ === /* P */1 ? stmt : undefined;
  var oneStatementIsChecked = state.checkedStmtIds.length === 1;
  var actPreCtxDataUpdated = function (param) {
    setState(function (__x) {
          return MM_wrk_editor.setPreCtxData(__x, preCtxData);
        });
    setHist(function (__x) {
          return MM_editor_history.editorHistSetMaxLength(__x, preCtxData.settingsV.val.editorHistMaxLength);
        });
  };
  React.useEffect((function () {
          actPreCtxDataUpdated(undefined);
        }), [
        preCtxData.settingsV.ver,
        preCtxData.ctxV.ver
      ]);
  var actOpenMainMenu = function (param) {
    Curry._1(setMainMenuIsOpened, (function (param) {
            return true;
          }));
  };
  var actCloseMainMenu = function (param) {
    Curry._1(setMainMenuIsOpened, (function (param) {
            return false;
          }));
  };
  var actAddNewStmt = function (param) {
    setState(function (st) {
          return MM_wrk_editor.addNewStmt(st)[0];
        });
  };
  var actDeleteCheckedStmts = function (param) {
    Expln_utils_promise.promiseMap(Expln_React_Modal.openModal(modalRef, (function (param) {
                return null;
              })), (function (modalId) {
            Expln_React_Modal.updateModal(modalRef, modalId, (function (param) {
                    var numOfSelectedStmts = state.checkedStmtIds.length;
                    return React.createElement(Paper, {
                                style: {
                                  padding: "10px"
                                },
                                children: Caml_option.some(React.createElement(Expln_React_Column.make, {
                                          spacing: 1,
                                          children: Caml_option.some(null)
                                        }, numOfSelectedStmts === state.stmts.length ? "Delete all steps?" : (
                                            numOfSelectedStmts === 1 ? "Delete the selected step?" : "Delete " + String(state.checkedStmtIds.length) + " selected steps?"
                                          ), React.createElement(Expln_React_Row.make, {
                                              children: Caml_option.some(null)
                                            }, React.createElement(Button, {
                                                  onClick: (function (param) {
                                                      Expln_React_Modal.closeModal(modalRef, modalId);
                                                    }),
                                                  children: "Cancel"
                                                }), React.createElement(Button, {
                                                  onClick: (function (param) {
                                                      Expln_React_Modal.closeModal(modalRef, modalId);
                                                      setState(MM_wrk_editor.deleteCheckedStmts);
                                                    }),
                                                  variant: "contained",
                                                  children: "Delete"
                                                }))))
                              });
                  }));
          }));
  };
  var actMoveCheckedStmtsUp = function (param) {
    setState(function (__x) {
          return MM_wrk_editor.moveCheckedStmts(__x, true);
        });
  };
  var actMoveCheckedStmtsDown = function (param) {
    setState(function (__x) {
          return MM_wrk_editor.moveCheckedStmts(__x, false);
        });
  };
  var actDuplicateStmt = function (param) {
    setState(function (st) {
          return MM_wrk_editor.uncheckAllStmts(MM_wrk_editor.duplicateCheckedStmt(st));
        });
  };
  var actBeginEdit0 = function (setter) {
    notifyEditInTempMode(function (param) {
          if (editIsActive) {
            return MM_react_common.openInfoDialog(modalRef, previousEditingIsNotCompletedText, undefined, previousEditingIsNotCompletedTitle, undefined);
          } else {
            return setState(setter);
          }
        });
  };
  var actBeginEdit = function (setter, stmtId) {
    notifyEditInTempMode(function (param) {
          if (editIsActive) {
            return MM_react_common.openInfoDialog(modalRef, previousEditingIsNotCompletedText, undefined, previousEditingIsNotCompletedTitle, undefined);
          } else {
            return setState(function (__x) {
                        return Curry._2(setter, __x, stmtId);
                      });
          }
        });
  };
  var actCompleteEditLabel = function (stmtId, newLabel) {
    var newLabel$1 = newLabel.trim();
    var msg = MM_wrk_editor.renameStmt(state, stmtId, newLabel$1);
    if (msg.TAG !== /* Ok */0) {
      return MM_react_common.openInfoDialog(modalRef, "Cannot rename this step: " + msg._0 + "", undefined, undefined, undefined);
    }
    var st = msg._0;
    setState(function (param) {
          return MM_wrk_editor.completeLabelEditMode(st, stmtId, newLabel$1);
        });
  };
  var actRestorePrevState = function (histIdx) {
    notifyEditInTempMode(function (param) {
          var msg = MM_editor_history.restoreEditorStateFromSnapshot(state, hist, histIdx);
          if (msg.TAG !== /* Ok */0) {
            return MM_react_common.openInfoDialog(modalRef, msg._0, undefined, "Could not restore editor state", undefined);
          }
          var editorState = msg._0;
          setState(function (param) {
                return editorState;
              });
        });
  };
  var viewOptions = {
    showCheckbox: showCheckbox,
    showLabel: showLabel,
    showType: showType,
    showJstf: showJstf,
    inlineMode: inlineMode,
    smallBtns: smallBtns
  };
  var actOpenRestorePrevStateDialog = function (param) {
    Expln_utils_promise.promiseMap(Expln_React_Modal.openModalFullScreen(modalRef, (function (param) {
                return null;
              })), (function (modalId) {
            Expln_React_Modal.updateModal(modalRef, modalId, (function (param) {
                    return React.createElement(MM_cmp_editor_hist.make, {
                                modalRef: modalRef,
                                editorState: MM_wrk_editor.removeAllTempData(state),
                                hist: hist,
                                onClose: (function (param) {
                                    Expln_React_Modal.closeModal(modalRef, modalId);
                                  }),
                                viewOptions: viewOptions,
                                onRestore: (function (histIdx) {
                                    actRestorePrevState(histIdx);
                                    Expln_React_Modal.closeModal(modalRef, modalId);
                                  })
                              });
                  }));
          }));
  };
  var actMergeTwoStmts = function (param) {
    var msg = MM_wrk_editor.findStmtsToMerge(state);
    if (msg.TAG !== /* Ok */0) {
      return MM_react_common.openInfoDialog(modalRef, msg._0, undefined, undefined, undefined);
    }
    var match = msg._0;
    var stmt2 = match[1];
    var stmt1 = match[0];
    Expln_utils_promise.promiseMap(Expln_React_Modal.openModal(modalRef, (function (param) {
                return null;
              })), (function (modalId) {
            Expln_React_Modal.updateModal(modalRef, modalId, (function (param) {
                    return React.createElement(MM_cmp_merge_two_stmts.make, {
                                stmt1: stmt1,
                                stmt2: stmt2,
                                onCancel: (function (param) {
                                    Expln_React_Modal.closeModal(modalRef, modalId);
                                  }),
                                onStmtSelected: (function (stmtToUse, stmtToRemove) {
                                    Expln_React_Modal.closeModal(modalRef, modalId);
                                    setState(function (st) {
                                          var st$1 = MM_wrk_editor.mergeStmts(st, stmtToUse.id, stmtToRemove.id);
                                          if (st$1.TAG === /* Ok */0) {
                                            return MM_wrk_editor.uncheckAllStmts(st$1._0);
                                          }
                                          MM_react_common.openInfoDialog(modalRef, st$1._0, undefined, undefined, undefined);
                                          return st;
                                        });
                                  })
                              });
                  }));
          }));
  };
  var actSearchAsrt = function (param) {
    var wrkCtx = state.wrkCtx;
    if (wrkCtx === undefined) {
      return ;
    }
    var wrkCtx$1 = Caml_option.valFromOption(wrkCtx);
    Expln_utils_promise.promiseMap(Expln_React_Modal.openModal(modalRef, (function (param) {
                return null;
              })), (function (modalId) {
            Expln_React_Modal.updateModal(modalRef, modalId, (function (param) {
                    return React.createElement(MM_cmp_search_asrt.make, {
                                modalRef: modalRef,
                                settingsVer: state.settingsV,
                                settings: state.settings,
                                preCtxVer: state.preCtxV,
                                preCtx: state.preCtx,
                                varsText: state.varsText,
                                disjText: state.disjText,
                                wrkCtx: wrkCtx$1,
                                frms: state.frms,
                                initialTyp: getLastUsedTyp(state.preCtx),
                                onTypChange: (function (__x) {
                                    saveLastUsedTyp(state.preCtx, __x, tempMode);
                                  }),
                                onCanceled: (function (param) {
                                    Expln_React_Modal.closeModal(modalRef, modalId);
                                  }),
                                onResultsSelected: (function (selectedResults) {
                                    Expln_React_Modal.closeModal(modalRef, modalId);
                                    setState(function (st) {
                                          return selectedResults.reduce(MM_wrk_editor.addNewStatements, st);
                                        });
                                  })
                              });
                  }));
          }));
  };
  var getIdOfFirstStmtToSubstitute = function (param) {
    if (state.checkedStmtIds.length >= 1) {
      return Caml_array.get(state.checkedStmtIds, 0);
    } else {
      return Belt_Option.map(Caml_option.undefined_to_opt(state.stmts.find(function (stmt) {
                          return MM_wrk_editor.hasSelectedText(stmt.cont);
                        })), (function (stmt) {
                    return stmt.id;
                  }));
    }
  };
  var getIdOfSecondStmtToSubstitute = function (firstId) {
    if (firstId !== undefined) {
      if (state.checkedStmtIds.length >= 2) {
        return Caml_array.get(state.checkedStmtIds, 1);
      } else {
        return Belt_Option.map(Caml_option.undefined_to_opt(state.stmts.find(function (stmt) {
                            if (stmt.id !== firstId) {
                              return MM_wrk_editor.hasSelectedText(stmt.cont);
                            } else {
                              return false;
                            }
                          })), (function (stmt) {
                      return stmt.id;
                    }));
      }
    }
    
  };
  var getTextToSubstitute = function (id) {
    if (id === undefined) {
      return ;
    }
    var stmt = MM_wrk_editor.editorGetStmtById(state, id);
    if (stmt === undefined) {
      return ;
    }
    var text = MM_wrk_editor.getSelectedText(stmt.cont);
    if (text !== undefined) {
      return text;
    } else {
      return MM_wrk_editor.contToStr(stmt.cont);
    }
  };
  var getExprsToSubstitute = function (param) {
    var id1 = getIdOfFirstStmtToSubstitute(undefined);
    var id2 = getIdOfSecondStmtToSubstitute(id1);
    return [
            getTextToSubstitute(id1),
            getTextToSubstitute(id2)
          ];
  };
  var actSubstitute = function (param) {
    var wrkCtx = state.wrkCtx;
    if (wrkCtx === undefined) {
      return ;
    }
    var wrkCtx$1 = Caml_option.valFromOption(wrkCtx);
    var match = getExprsToSubstitute(undefined);
    var expr2Init = match[1];
    var expr1Init = match[0];
    Expln_utils_promise.promiseMap(Expln_React_Modal.openModal(modalRef, (function (param) {
                return null;
              })), (function (modalId) {
            Expln_React_Modal.updateModal(modalRef, modalId, (function (param) {
                    return React.createElement(MM_cmp_substitution.make, {
                                modalRef: modalRef,
                                editorState: state,
                                expr1Init: expr1Init,
                                expr2Init: expr2Init,
                                wrkCtx: wrkCtx$1,
                                onCanceled: (function (param) {
                                    Expln_React_Modal.closeModal(modalRef, modalId);
                                  }),
                                onSubstitutionSelected: (function (wrkSubs) {
                                    Expln_React_Modal.closeModal(modalRef, modalId);
                                    setState(function (st) {
                                          return MM_wrk_editor.applySubstitutionForEditor(st, wrkSubs);
                                        });
                                  })
                              });
                  }));
          }));
  };
  var makeActTerminate = function (modalId, param) {
    MM_wrk_client.terminateWorker(undefined);
    Expln_React_Modal.closeModal(modalRef, modalId);
  };
  var prepareArgs0 = function (argLabels, rootStmts) {
    return rootStmts.filter(function (stmt) {
                  return argLabels.includes(stmt.label);
                }).map(function (stmt) {
                return stmt.expr;
              });
  };
  var getArgs0AndAsrtLabel = function (jstfText, rootStmts) {
    var match = MM_wrk_editor.parseJstf(jstfText);
    if (match.TAG !== /* Ok */0) {
      return ;
    }
    var match$1 = match._0;
    if (match$1 !== undefined) {
      return [
              prepareArgs0(match$1.args, rootStmts),
              match$1.label
            ];
    }
    
  };
  var actUnify = function (stmtId, params, initialDebugLevel, param) {
    var wrkCtx = state.wrkCtx;
    if (wrkCtx === undefined) {
      return ;
    }
    var wrkCtx$1 = Caml_option.valFromOption(wrkCtx);
    var varsText = state.varsText;
    var disjText = state.disjText;
    var state$1;
    if (stmtId !== undefined) {
      var state$2 = MM_wrk_editor.uncheckAllStmts(state);
      state$1 = MM_wrk_editor.toggleStmtChecked(state$2, stmtId);
    } else {
      state$1 = state;
    }
    var rootUserStmts = MM_wrk_editor.getRootStmtsForUnification(state$1);
    var rootStmts = rootUserStmts.map(MM_wrk_editor.userStmtToRootStmt);
    var stmt = MM_wrk_editor.getTheOnlyCheckedStmt(state$1);
    var singleProvableChecked = stmt !== undefined && stmt.typ === /* P */1 ? stmt : undefined;
    if (singleProvableChecked !== undefined) {
      var initialParams;
      if (params !== undefined) {
        initialParams = params;
      } else {
        var match = getArgs0AndAsrtLabel(singleProvableChecked.jstfText, rootStmts);
        initialParams = match !== undefined ? MM_provers.bottomUpProverParamsMake(match[1], undefined, undefined, undefined, undefined, undefined, match[0], undefined, undefined, undefined) : undefined;
      }
      Expln_utils_promise.promiseMap(Expln_React_Modal.openModal(modalRef, (function (param) {
                  return null;
                })), (function (modalId) {
              Expln_React_Modal.updateModal(modalRef, modalId, (function (param) {
                      return React.createElement(MM_cmp_unify_bottom_up.make, {
                                  modalRef: modalRef,
                                  settingsVer: state$1.settingsV,
                                  settings: state$1.settings,
                                  preCtxVer: state$1.preCtxV,
                                  preCtx: state$1.preCtx,
                                  frms: state$1.frms,
                                  parenCnt: state$1.parenCnt,
                                  varsText: varsText,
                                  disjText: disjText,
                                  wrkCtx: wrkCtx$1,
                                  rootStmts: rootUserStmts,
                                  reservedLabels: state$1.stmts.map(function (stmt) {
                                        return stmt.label;
                                      }),
                                  typeToPrefix: Belt_MapString.fromArray(state$1.settings.typeSettings.map(function (ts) {
                                            return [
                                                    ts.typ,
                                                    ts.prefix
                                                  ];
                                          })),
                                  initialParams: initialParams,
                                  initialDebugLevel: initialDebugLevel,
                                  onResultSelected: (function (newStmtsDto) {
                                      Expln_React_Modal.closeModal(modalRef, modalId);
                                      setState(function (st) {
                                            var st$1 = MM_wrk_editor.addNewStatements(st, newStmtsDto);
                                            return MM_wrk_editor.incUnifyAllIsRequiredCnt(MM_wrk_editor.uncheckAllStmts(st$1));
                                          });
                                    }),
                                  onCancel: (function (param) {
                                      Expln_React_Modal.closeModal(modalRef, modalId);
                                    })
                                });
                    }));
            }));
      return ;
    }
    Expln_utils_promise.promiseMap(Expln_React_Modal.openModal(modalRef, (function (param) {
                return MM_react_common.rndProgress("Unifying all", 0, undefined, undefined);
              })), (function (modalId) {
            Expln_React_Modal.updateModal(modalRef, modalId, (function (param) {
                    return MM_react_common.rndProgress("Unifying all", 0, (function (param) {
                                  return makeActTerminate(modalId, param);
                                }), undefined);
                  }));
            var rootStmts = rootUserStmts.map(MM_wrk_editor.userStmtToRootStmt);
            return Expln_utils_promise.promiseMap(MM_wrk_unify.unify(state$1.settingsV, state$1.settings, state$1.preCtxV, state$1.preCtx, varsText, disjText, rootStmts, undefined, state$1.syntaxTypes, state$1.settings.checkSyntax ? MM_wrk_editor.getAllExprsToSyntaxCheck(state$1, rootStmts) : undefined, 0, (function (msg) {
                              Expln_React_Modal.updateModal(modalRef, modalId, (function (param) {
                                      return MM_react_common.rndProgress(msg, undefined, (function (param) {
                                                    return makeActTerminate(modalId, param);
                                                  }), undefined);
                                    }));
                            })), (function (proofTreeDto) {
                          Expln_React_Modal.closeModal(modalRef, modalId);
                          Curry._1(setStatePriv, (function (st) {
                                  var st$1 = MM_wrk_editor.applyUnifyAllResults(st, proofTreeDto);
                                  editorSaveStateToLocStor(st$1, editorStateLocStorKey, tempMode);
                                  setHist(function (ht) {
                                        return MM_editor_history.editorHistAddSnapshot(ht, st$1);
                                      });
                                  return st$1;
                                }));
                        }));
          }));
  };
  React.useEffect((function () {
          if (unifyAllIsRequiredCnt.contents < state.unifyAllIsRequiredCnt) {
            unifyAllIsRequiredCnt.contents = state.unifyAllIsRequiredCnt;
            if (!MM_wrk_editor.editorStateHasErrors(state)) {
              actUnify(undefined, undefined, undefined, undefined);
            }
            
          }
          
        }), [state.unifyAllIsRequiredCnt]);
  var actExportProof = function (stmtId) {
    var match = MM_wrk_editor.generateCompressedProof(state, stmtId);
    if (match === undefined) {
      return ;
    }
    var proofTableWithoutTypes = match[2];
    var proofTableWithTypes = match[1];
    var proofText = match[0];
    Expln_utils_promise.promiseMap(Expln_React_Modal.openModal(modalRef, (function (param) {
                return null;
              })), (function (modalId) {
            Expln_React_Modal.updateModal(modalRef, modalId, (function (param) {
                    return React.createElement(MM_cmp_export_proof.make, {
                                proofText: proofText,
                                proofTableWithTypes: proofTableWithTypes,
                                proofTableWithoutTypes: proofTableWithoutTypes,
                                onClose: (function (param) {
                                    Expln_React_Modal.closeModal(modalRef, modalId);
                                  }),
                                tempMode: tempMode
                              });
                  }));
          }));
  };
  var rndSrcDtos = function (srcs) {
    return React.createElement(Expln_React_Column.make, {
                children: Caml_option.some(srcs.map(function (src, i) {
                          var readInstr = MM_wrk_editor.readInstrFromStr(src.readInstr);
                          var tmp;
                          if (readInstr === /* ReadAll */0) {
                            tmp = "read all";
                          } else {
                            var readInstrStr = readInstr === /* StopBefore */1 ? "stop before" : "stop after";
                            tmp = "" + readInstrStr + ": " + src.label + "";
                          }
                          return JsxPPXReactSupport.createElementWithKey(String(i), Paper, {
                                      style: {
                                        padding: "3px"
                                      },
                                      children: Caml_option.some(React.createElement(Expln_React_Column.make, {
                                                children: Caml_option.some(null)
                                              }, src.url, tmp))
                                    });
                        }))
              });
  };
  var loadEditorState = function (stateLocStor) {
    setState(function (param) {
          return MM_wrk_editor_json.createInitialEditorState(preCtxData.settingsV.ver, preCtxData.settingsV.val, stateLocStor.srcs, preCtxData.ctxV.ver, preCtxData.ctxV.val, stateLocStor);
        });
    Belt_Option.forEach(Caml_option.nullable_to_opt(reloadCtx.current), (function (reloadCtx) {
            Expln_utils_promise.promiseMap(Curry._1(reloadCtx, stateLocStor.srcs), (function (res) {
                    if (res.TAG === /* Ok */0) {
                      return ;
                    }
                    var msg = res._0;
                    Expln_utils_promise.promiseMap(Expln_React_Modal.openModal(modalRef, (function (param) {
                                return null;
                              })), (function (modalId) {
                            Expln_React_Modal.updateModal(modalRef, modalId, (function (param) {
                                    return React.createElement(Paper, {
                                                style: {
                                                  padding: "10px"
                                                },
                                                children: Caml_option.some(React.createElement(Expln_React_Column.make, {
                                                          spacing: 1,
                                                          children: Caml_option.some(null)
                                                        }, React.createElement("span", {
                                                              style: {
                                                                fontWeight: "bold"
                                                              }
                                                            }, "Could not reload the context because of the error:"), React.createElement("span", {
                                                              style: {
                                                                color: "red"
                                                              }
                                                            }, msg), React.createElement("span", undefined, "This error happened when loading the context:"), rndSrcDtos(stateLocStor.srcs), React.createElement(Button, {
                                                              onClick: (function (param) {
                                                                  Expln_React_Modal.closeModal(modalRef, modalId);
                                                                }),
                                                              variant: "contained",
                                                              children: "Ok"
                                                            })))
                                              });
                                  }));
                          }));
                  }));
          }));
  };
  var actImportFromJson = function (jsonStr) {
    var errorMsg = MM_wrk_editor_json.readEditorStateFromJsonStr(jsonStr);
    if (errorMsg.TAG === /* Ok */0) {
      loadEditorState(errorMsg._0);
      return true;
    }
    var errorMsg$1 = errorMsg._0;
    Expln_utils_promise.promiseMap(Expln_React_Modal.openModal(modalRef, (function (param) {
                return null;
              })), (function (modalId) {
            Expln_React_Modal.updateModal(modalRef, modalId, (function (param) {
                    return React.createElement(Paper, {
                                style: {
                                  padding: "10px"
                                },
                                children: Caml_option.some(React.createElement(Expln_React_Column.make, {
                                          spacing: 1,
                                          children: Caml_option.some(null)
                                        }, errorMsg$1, React.createElement(Button, {
                                              onClick: (function (param) {
                                                  Expln_React_Modal.closeModal(modalRef, modalId);
                                                }),
                                              variant: "contained",
                                              children: "Ok"
                                            })))
                              });
                  }));
          }));
    return false;
  };
  React.useEffect((function () {
          if (initialStateJsonStr !== undefined) {
            actImportFromJson(initialStateJsonStr);
          }
          
        }), []);
  var actShowInfoAboutGettingCompletedProof = function (title) {
    MM_react_common.openInfoDialog(modalRef, "In order to show a completed proof please do the following: 1) Make sure the step you want to show a completed proof for is marked with a green chekmark. If it is not, try to \"unify all\"; 2) Select the step you want to show a completed proof for; 3) Select \"Show completed proof\" menu item.", undefined, title, undefined);
  };
  var rndError = function (msgOpt, color) {
    if (msgOpt !== undefined) {
      return React.createElement("pre", {
                  style: {
                    color: color
                  }
                }, msgOpt);
    } else {
      return React.createElement(React.Fragment, undefined);
    }
  };
  var rndMainMenu = function (param) {
    if (!mainMenuIsOpened) {
      return null;
    }
    var mainMenuButtonRef$1 = mainMenuButtonRef.current;
    if (mainMenuButtonRef$1 == null) {
      return null;
    } else {
      return React.createElement(Expln_React_Menu.make, {
                  opn: true,
                  anchorEl: Caml_option.some(mainMenuButtonRef$1),
                  onClose: actCloseMainMenu,
                  children: Caml_option.some(null)
                }, React.createElement(MenuItem, {
                      onClick: (function (param) {
                          Curry._1(setMainMenuIsOpened, (function (param) {
                                  return false;
                                }));
                          Curry._1(setShowTabs, !showTabs);
                        }),
                      children: Caml_option.some(showTabs ? "Hide tabs" : "Show tabs")
                    }), React.createElement(MenuItem, {
                      onClick: (function (param) {
                          Curry._1(setMainMenuIsOpened, (function (param) {
                                  return false;
                                }));
                          Belt_Option.forEach(Caml_option.nullable_to_opt(openCtxSelector.current), (function (openCtxSelector) {
                                  Curry._1(openCtxSelector, undefined);
                                }));
                        }),
                      children: "Show context"
                    }), React.createElement(MenuItem, {
                      onClick: (function (param) {
                          Curry._1(setMainMenuIsOpened, (function (param) {
                                  return false;
                                }));
                          Expln_utils_promise.promiseMap(Expln_React_Modal.openModal(modalRef, (function (param) {
                                      return null;
                                    })), (function (modalId) {
                                  Expln_React_Modal.updateModal(modalRef, modalId, (function (param) {
                                          return React.createElement(MM_cmp_editor_view_options.make, {
                                                      showCheckbox: showCheckbox,
                                                      onShowCheckboxChange: (function (b) {
                                                          Curry._1(setShowCheckbox, (function (param) {
                                                                  return b;
                                                                }));
                                                        }),
                                                      showLabel: showLabel,
                                                      onShowLabelChange: (function (b) {
                                                          Curry._1(setShowLabel, (function (param) {
                                                                  return b;
                                                                }));
                                                        }),
                                                      showType: showType,
                                                      onShowTypeChange: (function (b) {
                                                          Curry._1(setShowType, (function (param) {
                                                                  return b;
                                                                }));
                                                        }),
                                                      showJstf: showJstf,
                                                      onShowJstfChange: (function (b) {
                                                          Curry._1(setShowJstf, (function (param) {
                                                                  return b;
                                                                }));
                                                        }),
                                                      inlineMode: inlineMode,
                                                      onInlineModeChange: (function (b) {
                                                          Curry._1(setInlineMode, (function (param) {
                                                                  return b;
                                                                }));
                                                        }),
                                                      smallBtns: smallBtns,
                                                      onSmallBtnsChange: (function (b) {
                                                          Curry._1(setSmallBtns, (function (param) {
                                                                  return b;
                                                                }));
                                                        }),
                                                      onClose: (function (param) {
                                                          Expln_React_Modal.closeModal(modalRef, modalId);
                                                        })
                                                    });
                                        }));
                                }));
                        }),
                      children: "View options"
                    }), React.createElement(MenuItem, {
                      onClick: (function (param) {
                          Curry._1(setMainMenuIsOpened, (function (param) {
                                  return false;
                                }));
                          Expln_utils_promise.promiseMap(Expln_React_Modal.openModal(modalRef, (function (param) {
                                      return null;
                                    })), (function (modalId) {
                                  Expln_React_Modal.updateModal(modalRef, modalId, (function (param) {
                                          return React.createElement(MM_cmp_export_state_to_url.make, {
                                                      editorStateBase64: Common.strToSafeBase64(Expln_utils_common.stringify(MM_wrk_editor_json.editorStateToEditorStateLocStor(state))),
                                                      onClose: (function (param) {
                                                          Expln_React_Modal.closeModal(modalRef, modalId);
                                                        })
                                                    });
                                        }));
                                }));
                        }),
                      children: "Export to URL"
                    }), React.createElement(MenuItem, {
                      onClick: (function (param) {
                          Curry._1(setMainMenuIsOpened, (function (param) {
                                  return false;
                                }));
                          Expln_utils_promise.promiseMap(Expln_React_Modal.openModal(modalRef, (function (param) {
                                      return null;
                                    })), (function (modalId) {
                                  Expln_React_Modal.updateModal(modalRef, modalId, (function (param) {
                                          return React.createElement(MM_cmp_export_state_to_json.make, {
                                                      jsonStr: Expln_utils_common.stringify(MM_wrk_editor_json.editorStateToEditorStateLocStor(state)),
                                                      onClose: (function (param) {
                                                          Expln_React_Modal.closeModal(modalRef, modalId);
                                                        }),
                                                      tempMode: tempMode
                                                    });
                                        }));
                                }));
                        }),
                      children: "Export to JSON"
                    }), React.createElement(MenuItem, {
                      onClick: (function (param) {
                          Curry._1(setMainMenuIsOpened, (function (param) {
                                  return false;
                                }));
                          Expln_utils_promise.promiseMap(Expln_React_Modal.openModal(modalRef, (function (param) {
                                      return null;
                                    })), (function (modalId) {
                                  Expln_React_Modal.updateModal(modalRef, modalId, (function (param) {
                                          return React.createElement(MM_cmp_import_from_json.make, {
                                                      onImport: (function (text) {
                                                          if (actImportFromJson(text)) {
                                                            return Expln_React_Modal.closeModal(modalRef, modalId);
                                                          }
                                                          
                                                        }),
                                                      onCancel: (function (param) {
                                                          Expln_React_Modal.closeModal(modalRef, modalId);
                                                        })
                                                    });
                                        }));
                                }));
                        }),
                      children: "Import from JSON ..."
                    }), React.createElement(MenuItem, {
                      onClick: (function (param) {
                          Curry._1(setMainMenuIsOpened, (function (param) {
                                  return false;
                                }));
                          var stmt = MM_wrk_editor.getTheOnlyCheckedStmt(state);
                          if (stmt === undefined) {
                            return actShowInfoAboutGettingCompletedProof("A single provable step should be selected");
                          }
                          if (stmt.typ !== /* P */1) {
                            return actShowInfoAboutGettingCompletedProof("A single provable step should be selected");
                          }
                          var match = stmt.proofStatus;
                          if (match === 0) {
                            return actExportProof(stmt.id);
                          } else {
                            return actShowInfoAboutGettingCompletedProof("A proof is not available");
                          }
                        }),
                      children: "Show completed proof"
                    }), React.createElement(MenuItem, {
                      onClick: (function (param) {
                          Curry._1(setMainMenuIsOpened, (function (param) {
                                  return false;
                                }));
                          notifyEditInTempMode(function (param) {
                                var state$1 = MM_wrk_editor.renumberSteps(state);
                                if (state$1.TAG !== /* Ok */0) {
                                  return MM_react_common.openInfoDialog(modalRef, state$1._0, undefined, undefined, undefined);
                                }
                                var state$2 = state$1._0;
                                setState(function (param) {
                                      return state$2;
                                    });
                              });
                        }),
                      children: "Renumber steps"
                    }));
    }
  };
  var rndButtons = function (param) {
    return React.createElement(Paper, {
                children: Caml_option.some(React.createElement(Expln_React_Row.make, {
                          spacing: 0,
                          childXsOffset: (function (idx) {
                              if (idx !== 11) {
                                return ;
                              } else {
                                return "auto";
                              }
                            }),
                          children: Caml_option.some(null)
                        }, React.createElement(Checkbox, {
                              style: smallBtns ? ({
                                    padding: "2px"
                                  }) : undefined,
                              disabled: editIsActive,
                              indeterminate: Belt_Option.isNone(mainCheckboxState),
                              checked: Belt_Option.getWithDefault(mainCheckboxState, false),
                              onChange: (function (param) {
                                  var action = mainCheckboxState !== undefined && !mainCheckboxState ? MM_wrk_editor.checkAllStmts : MM_wrk_editor.uncheckAllStmts;
                                  Curry._1(setStatePriv, (function (st) {
                                          var st$1 = Curry._1(action, st);
                                          editorSaveStateToLocStor(st$1, editorStateLocStorKey, tempMode);
                                          return st$1;
                                        }));
                                })
                            }), rndIconButton(React.createElement(ArrowDownward, {}), actMoveCheckedStmtsDown, !editIsActive && MM_wrk_editor.canMoveCheckedStmts(state, false), notifyEditInTempMode, undefined, "Move selected steps down", smallBtns, undefined), rndIconButton(React.createElement(ArrowUpward, {}), actMoveCheckedStmtsUp, !editIsActive && MM_wrk_editor.canMoveCheckedStmts(state, true), notifyEditInTempMode, undefined, "Move selected steps up", smallBtns, undefined), rndIconButton(React.createElement(Add, {}), actAddNewStmt, !editIsActive, notifyEditInTempMode, undefined, "Add new step (and place before selected steps if any)", smallBtns, undefined), rndIconButton(React.createElement(DeleteForever, {}), actDeleteCheckedStmts, !editIsActive && atLeastOneStmtIsChecked, notifyEditInTempMode, undefined, "Delete selected steps", smallBtns, undefined), rndIconButton(React.createElement(ControlPointDuplicate, {}), actDuplicateStmt, !editIsActive && MM_wrk_editor.isSingleStmtChecked(state), notifyEditInTempMode, undefined, "Duplicate selected step", smallBtns, undefined), rndIconButton(React.createElement(MergeType, {
                                  style: {
                                    transform: "rotate(180deg)"
                                  }
                                }), actMergeTwoStmts, oneStatementIsChecked, notifyEditInTempMode, undefined, "Merge two similar steps", smallBtns, undefined), rndIconButton(React.createElement(Restore, {}), actOpenRestorePrevStateDialog, !editIsActive, notifyEditInTempMode, undefined, "Restore previous state", smallBtns, undefined), rndIconButton(React.createElement(Search, {}), actSearchAsrt, generalModificationActionIsEnabled && Belt_MapString.size(state.frms) > 0, notifyEditInTempMode, undefined, "Add new steps from existing assertions (and place before selected steps if any)", smallBtns, undefined), rndIconButton(React.createElement(TextRotationNone, {}), actSubstitute, generalModificationActionIsEnabled && state.checkedStmtIds.length <= 2, notifyEditInTempMode, undefined, "Apply a substitution to all steps", smallBtns, undefined), rndIconButton(React.createElement(Hub, {}), (function (param) {
                                actUnify(undefined, undefined, undefined, undefined);
                              }), generalModificationActionIsEnabled && (!atLeastOneStmtIsChecked || Belt_Option.isSome(singleProvableChecked)) && state.stmts.length > 0, Belt_Option.isSome(singleProvableChecked) ? notifyEditInTempMode : undefined, undefined, "Unify all steps or unify selected provable bottom-up", smallBtns, undefined), rndIconButton(React.createElement(Menu, {}), actOpenMainMenu, !editIsActive, undefined, Caml_option.some(mainMenuButtonRef), "Additional actions", smallBtns, undefined)))
              });
  };
  var rndErrors = function (stmt) {
    if (Belt_Option.isSome(stmt.stmtErr) || Belt_Option.isSome(stmt.syntaxErr) || Belt_Option.isSome(stmt.unifErr)) {
      return React.createElement(Expln_React_Column.make, {
                  style: {
                    marginLeft: "10px"
                  },
                  children: Caml_option.some(null)
                }, rndError(stmt.stmtErr, "red"), rndError(Belt_Option.map(stmt.syntaxErr, (function (msg) {
                            if (msg === "") {
                              return "Syntax error.";
                            } else {
                              return "Syntax error - " + msg + ".";
                            }
                          })), "red"), rndError(stmt.unifErr, "darkgrey"));
    } else {
      return React.createElement(React.Fragment, undefined);
    }
  };
  var rndStmt = function (stmt) {
    var partial_arg = stmt.id;
    var partial_arg$1 = stmt.id;
    return React.createElement(MM_cmp_user_stmt.make, {
                modalRef: modalRef,
                settingsVer: state.settingsV,
                preCtxVer: state.preCtxV,
                varsText: state.varsText,
                wrkCtx: state.wrkCtx,
                frms: state.frms,
                parenCnt: state.parenCnt,
                syntaxTypes: state.syntaxTypes,
                parensMap: state.parensMap,
                typeColors: state.typeColors,
                preCtxColors: state.preCtxColors,
                wrkCtxColors: state.wrkCtxColors,
                editStmtsByLeftClick: state.settings.editStmtsByLeftClick,
                longClickEnabled: state.settings.longClickEnabled,
                longClickDelayMs: state.settings.longClickDelayMs,
                defaultStmtType: state.settings.defaultStmtType,
                showVisByDefault: state.settings.showVisByDefault,
                viewOptions: viewOptions,
                readOnly: false,
                stmt: stmt,
                onLabelEditRequested: (function (param) {
                    actBeginEdit(MM_wrk_editor.setLabelEditMode, stmt.id);
                  }),
                onLabelEditDone: (function (newLabel) {
                    actCompleteEditLabel(stmt.id, newLabel);
                  }),
                onLabelEditCancel: (function (newLabel) {
                    var stmtId = stmt.id;
                    var stmt$1 = MM_wrk_editor.editorGetStmtById(state, stmtId);
                    if (stmt$1 === undefined) {
                      return ;
                    }
                    var textOld = stmt$1.label;
                    if (textOld === newLabel || newLabel === "") {
                      return setState(function (__x) {
                                  return MM_wrk_editor.completeLabelEditMode(__x, stmtId, textOld);
                                });
                    } else {
                      Expln_utils_promise.promiseMap(Expln_React_Modal.openModal(modalRef, (function (param) {
                                  return null;
                                })), (function (modalId) {
                              Expln_React_Modal.updateModal(modalRef, modalId, (function (param) {
                                      return React.createElement(MM_cmp_save_or_discard.make, {
                                                  contOld: textOld,
                                                  contNew: newLabel,
                                                  onDiscard: (function (param) {
                                                      Expln_React_Modal.closeModal(modalRef, modalId);
                                                      setState(function (__x) {
                                                            return MM_wrk_editor.completeLabelEditMode(__x, stmtId, textOld);
                                                          });
                                                    }),
                                                  onSave: (function (param) {
                                                      Expln_React_Modal.closeModal(modalRef, modalId);
                                                      actCompleteEditLabel(stmtId, newLabel);
                                                    }),
                                                  onContinueEditing: (function (param) {
                                                      Expln_React_Modal.closeModal(modalRef, modalId);
                                                    })
                                                });
                                    }));
                            }));
                      return ;
                    }
                  }),
                onTypEditRequested: (function (param) {
                    actBeginEdit(MM_wrk_editor.setTypEditMode, stmt.id);
                  }),
                onTypEditDone: (function (newTyp, newIsGoal) {
                    setState(function (__x) {
                          return MM_wrk_editor.completeTypEditMode(__x, stmt.id, newTyp, newIsGoal);
                        });
                  }),
                onContEditRequested: (function (param) {
                    actBeginEdit(MM_wrk_editor.setContEditMode, stmt.id);
                  }),
                onContEditDone: (function (newContText) {
                    setState(function (__x) {
                          return MM_wrk_editor.completeContEditMode(__x, stmt.id, newContText);
                        });
                  }),
                onContEditCancel: (function (newContText) {
                    var stmtId = stmt.id;
                    var stmt$1 = MM_wrk_editor.editorGetStmtById(state, stmtId);
                    if (stmt$1 === undefined) {
                      return ;
                    }
                    var contOld = stmt$1.cont;
                    var contNew = MM_wrk_editor.strToCont(newContText, undefined, undefined, undefined);
                    var textOld = MM_wrk_editor.contToStr(contOld);
                    var textNew = MM_wrk_editor.contToStr(contNew);
                    if (textOld === textNew || textOld === "" && textNew === state.settings.defaultStmtType.trim()) {
                      if (textOld === "") {
                        return setState(function (__x) {
                                    return MM_wrk_editor.deleteStmt(__x, stmtId);
                                  });
                      } else {
                        return setState(function (__x) {
                                    return MM_wrk_editor.completeContEditMode(__x, stmtId, textOld);
                                  });
                      }
                    } else if (textNew === "") {
                      return setState(function (__x) {
                                  return MM_wrk_editor.completeContEditMode(__x, stmtId, textOld);
                                });
                    } else {
                      Expln_utils_promise.promiseMap(Expln_React_Modal.openModal(modalRef, (function (param) {
                                  return null;
                                })), (function (modalId) {
                              Expln_React_Modal.updateModal(modalRef, modalId, (function (param) {
                                      return React.createElement(MM_cmp_save_or_discard.make, {
                                                  contOld: MM_cmp_user_stmt.rndContText(contOld, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined),
                                                  removeStmt: textOld === "",
                                                  contNew: MM_cmp_user_stmt.rndContText(contNew, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined),
                                                  onDiscard: (function (param) {
                                                      Expln_React_Modal.closeModal(modalRef, modalId);
                                                      if (textOld === "") {
                                                        return setState(function (__x) {
                                                                    return MM_wrk_editor.deleteStmt(__x, stmtId);
                                                                  });
                                                      } else {
                                                        return setState(function (__x) {
                                                                    return MM_wrk_editor.completeContEditMode(__x, stmtId, textOld);
                                                                  });
                                                      }
                                                    }),
                                                  onSave: (function (param) {
                                                      Expln_React_Modal.closeModal(modalRef, modalId);
                                                      setState(function (__x) {
                                                            return MM_wrk_editor.completeContEditMode(__x, stmtId, textNew);
                                                          });
                                                    }),
                                                  onContinueEditing: (function (param) {
                                                      Expln_React_Modal.closeModal(modalRef, modalId);
                                                    })
                                                });
                                    }));
                            }));
                      return ;
                    }
                  }),
                onSyntaxTreeUpdated: (function (newStmtCont) {
                    setState(function (__x) {
                          return MM_wrk_editor.setStmtCont(__x, stmt.id, newStmtCont);
                        });
                  }),
                onJstfEditRequested: (function (param) {
                    actBeginEdit(MM_wrk_editor.setJstfEditMode, stmt.id);
                  }),
                onJstfEditDone: (function (newJstf) {
                    setState(function (__x) {
                          return MM_wrk_editor.completeJstfEditMode(__x, stmt.id, newJstf);
                        });
                  }),
                onJstfEditCancel: (function (newJstf) {
                    var stmtId = stmt.id;
                    var stmt$1 = MM_wrk_editor.editorGetStmtById(state, stmtId);
                    if (stmt$1 === undefined) {
                      return ;
                    }
                    var match = stmt$1.typ;
                    var textOld = match ? stmt$1.jstfText.trim() : MM_wrk_editor.defaultJstfForHyp;
                    var newJstfTextTrim = newJstf.trim();
                    var match$1 = stmt$1.typ;
                    var textNew = match$1 || MM_wrk_editor.defaultJstfForHyp !== newJstfTextTrim.toUpperCase() ? newJstfTextTrim : MM_wrk_editor.defaultJstfForHyp;
                    var nothingChanged = textOld === textNew;
                    if (nothingChanged) {
                      return setState(function (__x) {
                                  return MM_wrk_editor.completeJstfEditMode(__x, stmtId, textOld);
                                });
                    } else {
                      Expln_utils_promise.promiseMap(Expln_React_Modal.openModal(modalRef, (function (param) {
                                  return null;
                                })), (function (modalId) {
                              Expln_React_Modal.updateModal(modalRef, modalId, (function (param) {
                                      return React.createElement(MM_cmp_save_or_discard.make, {
                                                  contOld: textOld,
                                                  contNew: textNew,
                                                  onDiscard: (function (param) {
                                                      Expln_React_Modal.closeModal(modalRef, modalId);
                                                      setState(function (__x) {
                                                            return MM_wrk_editor.completeJstfEditMode(__x, stmtId, textOld);
                                                          });
                                                    }),
                                                  onSave: (function (param) {
                                                      Expln_React_Modal.closeModal(modalRef, modalId);
                                                      setState(function (__x) {
                                                            return MM_wrk_editor.completeJstfEditMode(__x, stmtId, textNew);
                                                          });
                                                    }),
                                                  onContinueEditing: (function (param) {
                                                      Expln_React_Modal.closeModal(modalRef, modalId);
                                                    })
                                                });
                                    }));
                            }));
                      return ;
                    }
                  }),
                checkboxDisabled: editIsActive,
                checkboxChecked: MM_wrk_editor.isStmtChecked(state, stmt.id),
                checkboxOnChange: (function (param) {
                    var id = stmt.id;
                    Curry._1(setStatePriv, (function (st) {
                            var st$1 = MM_wrk_editor.toggleStmtChecked(st, id);
                            editorSaveStateToLocStor(st$1, editorStateLocStorKey, tempMode);
                            return st$1;
                          }));
                  }),
                onGenerateProof: (function (param) {
                    actExportProof(stmt.id);
                  }),
                onDebug: (function (param) {
                    notifyEditInTempMode(function (param) {
                          var stmtId = stmt.id;
                          var st = MM_wrk_editor.uncheckAllStmts(state);
                          var st$1 = MM_wrk_editor.toggleStmtChecked(st, stmtId);
                          var stmt$1 = MM_wrk_editor.getTheOnlyCheckedStmt(st$1);
                          var singleProvableChecked = stmt$1 !== undefined && stmt$1.typ === /* P */1 ? stmt$1 : undefined;
                          if (singleProvableChecked === undefined) {
                            return ;
                          }
                          var rootUserStmts = MM_wrk_editor.getRootStmtsForUnification(st$1);
                          var rootStmts = rootUserStmts.map(MM_wrk_editor.userStmtToRootStmt);
                          var match = getArgs0AndAsrtLabel(singleProvableChecked.jstfText, rootStmts);
                          var params = match !== undefined ? MM_provers.bottomUpProverParamsMake(match[1], 1, /* Less */2, false, false, false, match[0], [], undefined, undefined) : MM_provers.bottomUpProverParamsMake(undefined, 1, /* Less */2, false, false, false, rootStmts.map(function (stmt) {
                                      return stmt.expr;
                                    }), [], undefined, undefined);
                          actUnify(stmtId, params, Belt_Option.isSome(params.asrtLabel) ? 2 : 1, undefined);
                        });
                  }),
                addStmtAbove: (function (param) {
                    return setState(function (st) {
                                var st$1 = MM_wrk_editor.uncheckAllStmts(st);
                                var st$2 = MM_wrk_editor.toggleStmtChecked(st$1, partial_arg);
                                var match = MM_wrk_editor.addNewStmt(st$2);
                                return MM_wrk_editor.uncheckAllStmts(MM_wrk_editor.setStmtCont(match[0], match[1], MM_wrk_editor.strToCont(param, undefined, undefined, undefined)));
                              });
                  }),
                addStmtBelow: (function (param) {
                    return setState(function (st) {
                                var st$1 = MM_wrk_editor.uncheckAllStmts(st);
                                var idx = st$1.stmts.findIndex(function (stmt) {
                                      return stmt.id === partial_arg$1;
                                    });
                                var st$2 = idx !== -1 && idx !== (st$1.stmts.length - 1 | 0) ? MM_wrk_editor.toggleStmtChecked(st$1, Caml_array.get(st$1.stmts, idx + 1 | 0).id) : st$1;
                                var match = MM_wrk_editor.addNewStmt(st$2);
                                return MM_wrk_editor.uncheckAllStmts(MM_wrk_editor.setStmtCont(match[0], match[1], MM_wrk_editor.strToCont(param, undefined, undefined, undefined)));
                              });
                  })
              });
  };
  var rndStmtAndErrors = function (stmt) {
    return JsxPPXReactSupport.createElementVariadicWithKey(stmt.id, Expln_React_Column.make, {
                spacing: 0,
                children: Caml_option.some(null)
              }, [
                rndStmt(stmt),
                rndErrors(stmt)
              ]);
  };
  var rndDescr = function (param) {
    return React.createElement(Expln_React_Row.make, {
                alignItems: "flex-start",
                spacing: 1,
                style: {
                  marginTop: "12px",
                  marginLeft: "7px"
                },
                children: Caml_option.some(null)
              }, React.createElement("span", {
                    style: {
                      cursor: "pointer"
                    },
                    onClick: (function (param) {
                        actBeginEdit0(MM_wrk_editor.setDescrEditMode);
                      })
                  }, "Description"), React.createElement(Expln_React_Column.make, {
                    children: Caml_option.some(React.createElement(MM_cmp_multiline_text.make, {
                              text: state.descr,
                              editMode: state.descrEditMode,
                              onEditRequested: (function (param) {
                                  actBeginEdit0(MM_wrk_editor.setDescrEditMode);
                                }),
                              onEditDone: (function (newText) {
                                  setState(function (__x) {
                                        return MM_wrk_editor.completeDescrEditMode(__x, newText);
                                      });
                                }),
                              onEditCancel: (function (newText) {
                                  var textOld = state.descr.trim();
                                  var textNew = newText.trim();
                                  if (textOld === textNew || textNew === "") {
                                    return setState(function (__x) {
                                                return MM_wrk_editor.completeDescrEditMode(__x, textOld);
                                              });
                                  } else {
                                    Expln_utils_promise.promiseMap(Expln_React_Modal.openModal(modalRef, (function (param) {
                                                return null;
                                              })), (function (modalId) {
                                            Expln_React_Modal.updateModal(modalRef, modalId, (function (param) {
                                                    return React.createElement(MM_cmp_save_or_discard.make, {
                                                                contOld: React.createElement("pre", undefined, textOld),
                                                                contNew: React.createElement("pre", undefined, textNew),
                                                                onDiscard: (function (param) {
                                                                    Expln_React_Modal.closeModal(modalRef, modalId);
                                                                    setState(function (__x) {
                                                                          return MM_wrk_editor.completeDescrEditMode(__x, textOld);
                                                                        });
                                                                  }),
                                                                onSave: (function (param) {
                                                                    Expln_React_Modal.closeModal(modalRef, modalId);
                                                                    setState(function (__x) {
                                                                          return MM_wrk_editor.completeDescrEditMode(__x, textNew);
                                                                        });
                                                                  }),
                                                                onContinueEditing: (function (param) {
                                                                    Expln_React_Modal.closeModal(modalRef, modalId);
                                                                  })
                                                              });
                                                  }));
                                          }));
                                    return ;
                                  }
                                }),
                              editByClick: false,
                              editByAltClick: true,
                              longClickEnabled: state.settings.longClickEnabled,
                              longClickDelayMs: state.settings.longClickDelayMs,
                              renderer: (function (str) {
                                  return React.createElement(Static_XML_to_HTML.make, {
                                              xmlStr: str
                                            });
                                }),
                              fullWidth: true,
                              buttonDirHor: false,
                              onHelp: (function (param) {
                                  Expln_utils_promise.promiseMap(Expln_React_Modal.openModal(modalRef, (function (param) {
                                              return null;
                                            })), (function (modalId) {
                                          Expln_React_Modal.updateModal(modalRef, modalId, (function (param) {
                                                  return React.createElement(XML_formatting_help.make, {
                                                              onClose: (function (param) {
                                                                  Expln_React_Modal.closeModal(modalRef, modalId);
                                                                })
                                                            });
                                                }));
                                        }));
                                })
                            }))
                  }));
  };
  var rndVars = function (param) {
    return React.createElement(Expln_React_Row.make, {
                alignItems: "flex-start",
                spacing: 1,
                style: {
                  marginTop: "3px",
                  marginLeft: "7px"
                },
                children: Caml_option.some(null)
              }, React.createElement("span", {
                    style: {
                      cursor: "pointer"
                    },
                    onClick: (function (param) {
                        actBeginEdit0(MM_wrk_editor.setVarsEditMode);
                      })
                  }, "Variables"), React.createElement(Expln_React_Column.make, {
                    children: Caml_option.some(null)
                  }, React.createElement(MM_cmp_multiline_text.make, {
                        text: state.varsText,
                        editMode: state.varsEditMode,
                        onEditRequested: (function (param) {
                            actBeginEdit0(MM_wrk_editor.setVarsEditMode);
                          }),
                        onEditDone: (function (newText) {
                            setState(function (__x) {
                                  return MM_wrk_editor.completeVarsEditMode(__x, newText);
                                });
                          }),
                        onEditCancel: (function (newText) {
                            var textOld = state.varsText.trim();
                            var textNew = newText.trim();
                            if (textOld === textNew || textNew === "") {
                              return setState(function (__x) {
                                          return MM_wrk_editor.completeVarsEditMode(__x, textOld);
                                        });
                            } else {
                              Expln_utils_promise.promiseMap(Expln_React_Modal.openModal(modalRef, (function (param) {
                                          return null;
                                        })), (function (modalId) {
                                      Expln_React_Modal.updateModal(modalRef, modalId, (function (param) {
                                              return React.createElement(MM_cmp_save_or_discard.make, {
                                                          contOld: React.createElement("pre", undefined, textOld),
                                                          contNew: React.createElement("pre", undefined, textNew),
                                                          onDiscard: (function (param) {
                                                              Expln_React_Modal.closeModal(modalRef, modalId);
                                                              setState(function (__x) {
                                                                    return MM_wrk_editor.completeVarsEditMode(__x, textOld);
                                                                  });
                                                            }),
                                                          onSave: (function (param) {
                                                              Expln_React_Modal.closeModal(modalRef, modalId);
                                                              setState(function (__x) {
                                                                    return MM_wrk_editor.completeVarsEditMode(__x, textNew);
                                                                  });
                                                            }),
                                                          onContinueEditing: (function (param) {
                                                              Expln_React_Modal.closeModal(modalRef, modalId);
                                                            })
                                                        });
                                            }));
                                    }));
                              return ;
                            }
                          }),
                        editByClick: true,
                        editByAltClick: true,
                        longClickEnabled: state.settings.longClickEnabled,
                        longClickDelayMs: state.settings.longClickDelayMs
                      }), rndError(state.varsErr, "red")));
  };
  var rndDisj = function (param) {
    return React.createElement(Expln_React_Row.make, {
                alignItems: "flex-start",
                spacing: 1,
                style: {
                  marginLeft: "7px"
                },
                children: Caml_option.some(null)
              }, React.createElement("span", {
                    style: {
                      cursor: "pointer"
                    },
                    onClick: (function (param) {
                        actBeginEdit0(MM_wrk_editor.setDisjEditMode);
                      })
                  }, "Disjoints"), React.createElement(Expln_React_Column.make, {
                    children: Caml_option.some(null)
                  }, React.createElement(MM_cmp_multiline_text.make, {
                        text: state.disjText,
                        editMode: state.disjEditMode,
                        onEditRequested: (function (param) {
                            actBeginEdit0(MM_wrk_editor.setDisjEditMode);
                          }),
                        onEditDone: (function (newText) {
                            setState(function (__x) {
                                  return MM_wrk_editor.completeDisjEditMode(__x, newText);
                                });
                          }),
                        onEditCancel: (function (newText) {
                            var textOld = state.disjText.trim();
                            var textNew = newText.trim();
                            if (textOld === textNew || textNew === "") {
                              return setState(function (__x) {
                                          return MM_wrk_editor.completeDisjEditMode(__x, textOld);
                                        });
                            } else {
                              Expln_utils_promise.promiseMap(Expln_React_Modal.openModal(modalRef, (function (param) {
                                          return null;
                                        })), (function (modalId) {
                                      Expln_React_Modal.updateModal(modalRef, modalId, (function (param) {
                                              return React.createElement(MM_cmp_save_or_discard.make, {
                                                          contOld: React.createElement("pre", undefined, textOld),
                                                          contNew: React.createElement("pre", undefined, textNew),
                                                          onDiscard: (function (param) {
                                                              Expln_React_Modal.closeModal(modalRef, modalId);
                                                              setState(function (__x) {
                                                                    return MM_wrk_editor.completeDisjEditMode(__x, textOld);
                                                                  });
                                                            }),
                                                          onSave: (function (param) {
                                                              Expln_React_Modal.closeModal(modalRef, modalId);
                                                              setState(function (__x) {
                                                                    return MM_wrk_editor.completeDisjEditMode(__x, textNew);
                                                                  });
                                                            }),
                                                          onContinueEditing: (function (param) {
                                                              Expln_React_Modal.closeModal(modalRef, modalId);
                                                            })
                                                        });
                                            }));
                                    }));
                              return ;
                            }
                          }),
                        editByClick: true,
                        editByAltClick: true,
                        longClickEnabled: state.settings.longClickEnabled,
                        longClickDelayMs: state.settings.longClickDelayMs
                      }), rndError(state.disjErr, "red")));
  };
  var rndStmts = function (param) {
    return React.createElement(Expln_React_Column.make, {
                spacing: 0,
                children: Caml_option.some(state.stmts.map(rndStmtAndErrors))
              });
  };
  return React.createElement(Expln_React_ContentWithStickyHeader.make, {
              top: props.top,
              header: rndButtons(undefined),
              content: (function (param) {
                  return React.createElement(Expln_React_Column.make, {
                              spacing: 0,
                              children: Caml_option.some(null)
                            }, rndMainMenu(undefined), rndDescr(undefined), rndVars(undefined), rndDisj(undefined), rndStmts(undefined));
                })
            });
}

var make = MM_cmp_editor;

exports.unifyAllIsRequiredCnt = unifyAllIsRequiredCnt;
exports.editorSaveStateToLocStor = editorSaveStateToLocStor;
exports.editorHistRegLocStorKey = editorHistRegLocStorKey;
exports.editorHistTmpLocStorKey = editorHistTmpLocStorKey;
exports.getHistLockStorKey = getHistLockStorKey;
exports.histSaveToLocStor = histSaveToLocStor;
exports.histReadFromLocStor = histReadFromLocStor;
exports.rndIconButton = rndIconButton;
exports.editorStateLocStorKey = editorStateLocStorKey;
exports.lastUsedAsrtSearchTypLocStorKey = lastUsedAsrtSearchTypLocStorKey;
exports.saveLastUsedTyp = saveLastUsedTyp;
exports.getLastUsedTyp = getLastUsedTyp;
exports.jsonStrOptToEditorStateLocStor = jsonStrOptToEditorStateLocStor;
exports.previousEditingIsNotCompletedTitle = previousEditingIsNotCompletedTitle;
exports.previousEditingIsNotCompletedText = previousEditingIsNotCompletedText;
exports.editingInTempModeTitle = editingInTempModeTitle;
exports.editingInTempModeText = editingInTempModeText;
exports.make = make;
/* react Not a pure module */
